const refreshState = {
    isUnAuthorized: false,
    reIssueFailed: false,
};

export default refreshState;
